module.exports = __webpack_public_path__ + "static/Q2-2023_Investor_call_Dial-in_information-d38ba37e7ae0c6c0113d3b270bda957c.pdf";